import React from 'react';
import classNames from 'classnames/bind';
import Loader from "../../../../Loader";
import { useMediaQuery } from "../../../../hooks";
import styles from './SearchLoader.css';
var cx = classNames.bind(styles);
export var SearchLoader = function SearchLoader() {
  var breakpoints = useMediaQuery('xs');
  var isMobile = breakpoints.xs;
  var loaderView = isMobile ? 'circle' : 'flow';
  var rootClassName = cx('root', {
    'root--desktop-position': !isMobile
  });
  return /*#__PURE__*/React.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/React.createElement(Loader, {
    view: loaderView,
    color: "N80"
  }));
};